import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import { extraContent as extraContentLocomotive, components as componentsLocomotive } from "./components/locomotive";
import { extraContent as extraContentHairdryer, components as componentsHairdryer } from "./components/hairdryer";
import {
  extraContent as extraContentPressureCooker,
  components as componentsPressureCooker,
} from "./components/pressure-cooker";

const principle: Slide = {
  title: "",
  description:
    "Sharpness is a psychoacoustic quantity reflecting the sensation induced by high frequency components.  Sounds with a higher amount of high frequency components (i.e. where the spectral distribution is shifted towards higher frequencies) will be perceived as being sharper.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [
            {
              name: "Locomotive",
            },
            {
              name: "Hairdryer",
            },
            {
              name: "Pressure Cooker",
            },
          ],
        },
      ],
      extraContent: [extraContentLocomotive, extraContentHairdryer, extraContentPressureCooker],
      components: [componentsLocomotive, componentsHairdryer, componentsPressureCooker],
    },
  },
};

export default principle;
